import chroma from 'chroma-js'
import {
  MathUtils,
  WebGLRenderer,
  PerspectiveCamera,
  Scene,
  Vector3,
  ShaderMaterial,
  Color,
  Mesh,
} from 'three'

import Polyline from './Polyline'
import { vertexShader, fragmentShader } from './shaders'

function App (canvas, conf, preserveDrawingBuffer) {
  let renderer, scene, camera
  const rnd = MathUtils.randFloat

  const ny = 100
  const uTime = { value: 0 }
  const polylines = []

  const resizeObserver = new ResizeObserver(updateSize)

  init()

  function init () {
    renderer = new WebGLRenderer({ canvas, antialias: true, preserveDrawingBuffer })
    camera = new PerspectiveCamera()

    updateSize()
    resizeObserver.observe(canvas)

    initScene()
    requestAnimationFrame(animate)
  }

  function initScene () {
    scene = new Scene()
    const dx = 2 / (conf.nx), dy = -2 / (ny - 1)
    const ox = -1 + dx / 2, oy = 1
    const mat2 = Float32Array.from([
      Math.cos(conf.angle),
      -Math.sin(conf.angle),
      Math.sin(conf.angle),
      Math.cos(conf.angle),
    ])
    for (let i = 0; i < conf.nx; i++) {
      const points = []
      for (let j = 0; j < ny; j++) {
        const x = ox + i * dx, y = oy + j * dy
        points.push(new Vector3(x, y, 0))
      }
      const polyline = new Polyline({ points })
      polylines.push(polyline)

      const material = new ShaderMaterial({
        uniforms: {
          uTime,
          uTimeCoef: { value: conf.timeCoef },
          uMat2: { value: mat2 },
          uSize: { value: 1.5 / conf.nx },
          uRnd1: { value: new Vector3(rnd(-1, 1), rnd(-1, 1), rnd(-1, 1)) },
          uRnd2: { value: new Vector3(rnd(-1, 1), rnd(-1, 1), rnd(-1, 1)) },
          uRnd3: { value: new Vector3(rnd(-1, 1), rnd(-1, 1), rnd(-1, 1)) },
          uRnd4: { value: new Vector3(rnd(-1, 1), rnd(-1, 1), rnd(-1, 1)) },
          uRnd5: { value: new Vector3(rnd(0.2, 0.5), rnd(0.3, 0.6), rnd(0.4, 0.7)) },
          uColor1: { value: new Color(conf.cscale(i / conf.nx).hex()) },
          uColor2: { value: new Color(conf.cscale(i / conf.nx).darken(conf.darken).hex()) }
        },
        vertexShader,
        fragmentShader
      })
      const mesh = new Mesh(polyline.geometry, material)
      scene.add(mesh)
    }
  }

  // function initRandomScene () {
  //   conf.nx = Math.floor(rnd(20, 200))
  //   conf.cscale = randomCScale()
  //   conf.darken = rnd(0, 1) > 0.5 ? rnd(-4, -0.5) : rnd(0.5, 4)
  //   conf.angle = rnd(0, 2 * Math.PI)
  //   conf.timeCoef = rnd(0.05, 0.2)
  //   disposeScene()
  //   initScene()
  // }

  function disposeScene () {
    resizeObserver.disconnect()
    for (let i = 0; i < scene.children.length; i++) {
      const mesh = scene.children[i]
      scene.remove(mesh)
      mesh.geometry.dispose()
      mesh.material.dispose()
    }
  }

  // function randomCScale () {
  //   const colors = [], n = 2 + Math.floor(rnd(0, 4))
  //   for (let i = 0; i < n; i++) {
  //     colors.push(chroma.random())
  //   }
  //   return chroma.scale(colors).mode('lch')
  // }

  function animate (t) {
    uTime.value = t * 0.001
    renderer.render(scene, camera)
    requestAnimationFrame(animate)
  }

  function updateSize() {
    renderer.setSize(canvas.offsetWidth, canvas.offsetHeight)
  }

  return disposeScene
}

export const init = (canvas, config, preserveDrawingBuffer) => {
  try {
    return App(canvas, {
      ...config,
      cscale: chroma.scale(config.cscale).mode('lch'),
    }, preserveDrawingBuffer)
  } catch (error) {
    console.error(error)
  }
}
